<template>
    <header class="header" id="header" v-if="result" :class="{ 'header__dark' : $route.meta.showDarkHeader }">

        <router-link class="header__logo" to="/" :class="{'hide__dark__logo' : !$route.meta.showDarkHeader}">
            <img :src="result.setting.data.attributes.header.logoAlternate.data.attributes.url" :alt="result.setting.data.attributes.header.logoAlternate.data.attributes.alternativeText">
        </router-link>

        <router-link class="header__logo header__light" to="/" :class="{'hide__light__logo' : $route.meta.showDarkHeader}">
            <img :src="result.setting.data.attributes.header.logo.data.attributes.url" :alt="result.setting.data.attributes.header.logo.data.attributes.alternativeText">
        </router-link>

        <main-menu v-if="!$route.meta.showMenu"></main-menu>

        <div class="drawer__holder" @click="toggleIsActive" v-if="!$route.meta.showMenu">
            Menu
            <div class="hamburger-toggle" id="hamburger-toggle">
                <button class="hamburger hamburger--spin" :class="{ 'is-active': isActive }" type="button">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                    <span class="vh closed">Open Menu</span>
                    <span class="vh opened">Close Menu</span>
                </button>
            </div>
        </div>

        <div class="header__buttons" v-if="$route.meta.showMenu">
            <!-- <router-link to="/" class="general-button white-background">
                Rain Digital
                <span>
                    <arrow-right/>
                </span>
            </router-link> -->
            <router-link to="/contact" class="general-button main-accent">
                Work with us
            </router-link>
        </div>

        <drawer v-if="!$route.meta.showMenu"/>
    </header>
</template>
<script lang="ts">

import { defineComponent, ref, onMounted } from 'vue';

import { useQuery } from '@vue/apollo-composable'
import { HEADER_QUERY } from '../../graphql/header'

import router from '../../routes'

import MainMenu from './MainMenu.vue'
import Drawer from './Drawer.vue'
import ArrowRight from '../svg/ArrowRight.vue'

export default defineComponent({
    components: {
        MainMenu,
        Drawer,
        ArrowRight
    },
    setup() {
        const homeurl: string = import.meta.env.VITE_API_URL
        const fronturl: string = import.meta.env.BASE_URL

        const query = ref(HEADER_QUERY)
        const { result } = useQuery(query)

        function removeIsDrawerClasses() {
          const drawers = document.querySelectorAll('.is-drawer');
          drawers.forEach((drawer) => {
            drawer.classList.remove('is-drawer');
          });
        }

        router.afterEach((to, from) => {
            removeIsDrawerClasses();
            if (isActive.value) {
                isActive.value = false;
            }
            document.body.classList.remove('is-drawer');
        });

        const isActive = ref(false);

        const toggleIsActive = () => {
            isActive.value = !isActive.value;
            document.body.classList.toggle('is-drawer');
        };

        return {
            result,
            fronturl,
            homeurl,
            isActive,
            toggleIsActive,
        }
    }
})

</script>
